export default "__VITE_ASSET__7bdf3b8e__"